"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setState = exports.cancelRequestTimeouts = exports.cancelRequestsByGroup = exports.getServiceUrl = exports.extractToken = exports.actionNames = exports.setupDiscovery = exports.injectImpersoToken = exports.exchangeAuthToken = exports.logout = exports.setupPersistence = exports.removePersistence = exports.lockPersistence = exports.unlockPersistence = exports.setup = exports.poll = exports.put = exports.remove = exports.post = exports.get = exports.request = void 0;
const middleware_1 = __importDefault(require("./middleware"));
const actionNames = __importStar(require("./constants/actions"));
exports.actionNames = actionNames;
const request = (newRequest) => (Object.assign({ type: actionNames.API_REQUEST }, newRequest));
exports.request = request;
const get = (name, service, url, options) => request({
    payload: undefined,
    meta: Object.assign({ method: 'GET', name,
        service,
        url }, options),
});
exports.get = get;
const post = (name, service, url, data, options) => request({
    payload: data,
    meta: Object.assign({ method: 'POST', name,
        service,
        url }, options),
});
exports.post = post;
const remove = (name, service, url, options) => request({
    payload: undefined,
    meta: Object.assign({ method: 'DELETE', name,
        service,
        url }, options),
});
exports.remove = remove;
const put = (name, service, url, data, options) => request({
    payload: data,
    meta: Object.assign({ method: 'PUT', name,
        service,
        url }, options),
});
exports.put = put;
const poll = (apiRequest, options) => ({
    type: actionNames.API_POLL,
    payload: apiRequest,
    meta: options,
});
exports.poll = poll;
const setup = () => ({
    type: actionNames.API_SETUP,
});
exports.setup = setup;
const unlockPersistence = (args) => ({
    type: actionNames.API_UNLOCK_PERSISTENCE,
    payload: args,
});
exports.unlockPersistence = unlockPersistence;
const lockPersistence = (args) => ({
    type: actionNames.API_LOCK_PERSISTENCE,
    payload: args,
});
exports.lockPersistence = lockPersistence;
const removePersistence = () => ({
    type: actionNames.API_REMOVE_PERSISTENCE,
});
exports.removePersistence = removePersistence;
const setupPersistence = (args) => ({
    type: actionNames.API_STORE_SESSION,
    payload: args,
});
exports.setupPersistence = setupPersistence;
const logout = (redirectUrl) => ({
    type: actionNames.API_LOGOUT,
    payload: {
        redirectUrl,
    },
});
exports.logout = logout;
const exchangeAuthToken = (params) => ({
    type: actionNames.API_EXCHANGE_AUTH_TOKEN,
    payload: params,
});
exports.exchangeAuthToken = exchangeAuthToken;
const injectImpersoToken = (accessToken) => ({
    type: actionNames.API_INJECT_IMPERSO_TOKEN,
    payload: accessToken,
});
exports.injectImpersoToken = injectImpersoToken;
const setupDiscovery = () => ({
    type: actionNames.API_SETUP_DISCOVERY,
});
exports.setupDiscovery = setupDiscovery;
const extractToken = () => ({
    type: actionNames.API_EXTRACT_TOKEN,
});
exports.extractToken = extractToken;
const getServiceUrl = (type) => ({
    type: actionNames.API_GET_SERVICE_URL,
    payload: type,
});
exports.getServiceUrl = getServiceUrl;
const cancelRequestsByGroup = (groupId) => ({
    type: actionNames.API_CANCEL_REQUESTS_BY_GROUP,
    payload: groupId,
});
exports.cancelRequestsByGroup = cancelRequestsByGroup;
const cancelRequestTimeouts = () => ({
    type: actionNames.API_CANCEL_REQUEST_TIMEOUTS,
});
exports.cancelRequestTimeouts = cancelRequestTimeouts;
const setState = (state) => ({
    type: actionNames.API_SET_STATE,
    payload: state,
});
exports.setState = setState;
exports.default = middleware_1.default;
